import log from 'loglevel'
import axios from 'axios'

import Cache from '@/syslic/utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class DeliveryFreight {
  constructor() {
    log.info('[INFO] Initialize Delivery Item Module')
    this.cache = new Cache()
  }

  fetchAllFreight(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/order/delivery/freight/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch delivery freight')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch deliverys')
            log.error(error)
            reject(error.response)
          })
      })

      return promise
    })

    return result
  }

  fetchFreight(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/order/delivery/freight/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch delivery freight')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch delivery freight')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateFreight(id, deliveryData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/order/delivery/freight/${id}/`, deliveryData)
        .then(response => {
          log.debug('[DEBUG] Success to update delivery freight')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update delivery freight')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addFreight(deliveryData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/order/delivery/freight/', deliveryData)
        .then(response => {
          log.debug('[DEBUG] Success to add delivery freight')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add delivery freight')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteFreight(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/order/delivery/freight/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete delivery freight')
          this.cache.reset()
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete delivery freight')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
